module.exports = __webpack_public_path__ + "img/ico-reservas.424e669b.svg";